import React from 'react';

export class Image extends React.Component {
  render() {
    const short_name = this.props.short_name;

    return (
      <img
        ref={img => this.img = img}
        src={`/img/attributes_name/${short_name}.svg`}
        alt={short_name}
        title={short_name}
        role="img"
        onError={() => {
          this.img.onerror = null;
          // Якщо немає "no_icon.svg" тоді утворюється нескінченний цикл
          this.img.src = '/img/attributes_name/no_icon.svg';
        }}
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/snippets/ExplanationAttributes/impl/share/Image.jsx